<template>
  <el-dialog :title="title" :visible.sync="setShow" width="28%">
    <div class="mb-1">
      <p>
        To complete the opt-in process, please provide your password
      </p>
    </div>
    <el-form :model="form" label-position="top" ref="form">
      <el-row type="flex">
        <el-col :span="24">
          <el-form-item
            label=""
            prop="password"
            :rules="validateField('Password')"
          >
            <el-input type="password" v-model="form.password" show-password>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button plain size="medium" @click="cancel">Cancel</el-button>
      <el-button
        type="primary"
        size="medium"
        :loading="confirming"
        @click="confirm"
        >Confirm</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { userData, userOrganisation } from "@/lib/utils";
import * as actions from "@/store/action-types";

export default {
  name: "ProductOptIn",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    product: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      form: {
        identifier: userData().user && userData().user.email,
        password: ""
      },
      confirming: false,
      loading: false
    };
  },
  computed: {
    setShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      }
    },
    productInformation() {
      const { features } = userOrganisation();
      return features && features[this.product];
    },
    title() {
      return `Opt-in for ${this.productInformation.name}`;
    }
  },

  methods: {
    cancel() {
      this.setShow = false;
      this.$emit("cancel");
      this.form.daterange = [];
    },
    confirm() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return false;
        }
        this.confirming = true;
        this.$http
          .post(`organisations/features/${this.productInformation.id}`, {
            method: "PUT"
          })
          .then(response => {
            const resData = response.data;
            if (resData.status === "error") {
              this.confirming = false;
              this.handleErrors(resData);
            } else {
              this.authenticate();
            }
          })
          .catch(() => {
            this.confirming = false;
            this.notification("Error", "An unknown error occurred", "danger");
          });
      });
    },
    authenticate() {
      this.$http
        .post("auth/local/users/authenticate", {
          body: this.form,
          method: "POST"
        })
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.confirming = false;
            this.handleErrors(resData);
          } else {
            this.$store.dispatch(actions.LOGIN, resData);
            this.confirming = false;
            this.setShow = false;
            this.$emit("success");
          }
        })
        .catch(() => {
          this.confirming = false;
          this.notification("Error", "An unknown error occurred", "danger");
        });
    }
  }
};
</script>
